/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {Component} from '../models/component';
import {EntityStore} from './entityStore';

export class OrderComponentStore extends EntityStore {
  components = [];

  constructor(rootStore) {
    super(rootStore, 'components', Api.components, Component);
  }

  loadByOrderId(orderId) {
    return this.loadAll({
      params: {orderId},
      mapper: (c) => this.createModelInstance({...c, orderId}),
    });
  }

  filterByOrderId(orderId) {
    return this.components.filter((c) => c.orderId === orderId);
  }
}

decorate(OrderComponentStore, {
  components: observable,
});
